import type { ReactNode } from "react";
import { cn } from "../../utilities/tailwind";

type BadgeProperties = {
  /**
   * **Required.** Badge stylings wrap the children passed to the `Badge`.
   */
  children: ReactNode;
  /**
   * add additional classes to the component for styling
   */
  className?: string | undefined;
  /**
   * Applies disabled stylings to the `Badge` component.
   */
  isDisabled?: boolean | undefined;
};

export const Badge = ({
  children,
  className = "",
  isDisabled = false,
  ...properties
}: BadgeProperties) => {
  const twClassName = cn(
    "flex size-6 w-fit min-w-6 items-center justify-center overflow-hidden rounded-xl bg-primary px-1 py-px text-s-body-extra-bold text-on-primary",
    {
      "border border-disabled-variant bg-disabled text-disabled-variant":
        isDisabled,
    },
    className,
  );

  return (
    <div className={twClassName} {...properties}>
      {children}
    </div>
  );
};
Badge.displayName = "Badge";
